"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generalStore = void 0;
const api_1 = require("client/api");
const mobx_1 = require("mobx");
// const log = new Logger('store/store');
class GeneralStore {
    constructor() {
        // @observable menuOpen: boolean = true;
        this.menuOpen = true;
        this.setMenuOpen = (open) => {
            this.menuOpen = open;
        };
        this.exportAuditLogs = async (data, master = false) => {
            // console.log(data);
            const result = await api_1.GoogleEndpoint.exportAudit.apiCall(null, {
                data,
                master
            });
            if (api_1.isError(result)) {
                console.log("error");
            }
            else {
                console.log("pass");
            }
        };
        // Given zipcode, returns State abbreviation
        this.getState = (zipcode) => {
            // Ensure you don't parse codes that start with 0 as octal values
            const zip = parseInt(zipcode, 10);
            let stateAbbr = '';
            // Code blocks alphabetized by state
            if (zip >= 35000 && zip <= 36999) {
                stateAbbr = 'AL';
            }
            else if (zip >= 99500 && zip <= 99999) {
                stateAbbr = 'AK';
            }
            else if (zip >= 85000 && zip <= 86999) {
                stateAbbr = 'AZ';
            }
            else if (zip >= 71600 && zip <= 72999) {
                stateAbbr = 'AR';
            }
            else if (zip >= 90000 && zip <= 96699) {
                stateAbbr = 'CA';
            }
            else if (zip >= 80000 && zip <= 81999) {
                stateAbbr = 'CO';
            }
            else if (zip >= 6000 && zip <= 6999) {
                stateAbbr = 'CT';
            }
            else if (zip >= 19700 && zip <= 19999) {
                stateAbbr = 'DE';
            }
            else if (zip >= 32000 && zip <= 34999) {
                stateAbbr = 'FL';
            }
            else if (zip >= 30000 && zip <= 31999) {
                stateAbbr = 'GA';
            }
            else if (zip >= 96700 && zip <= 96999) {
                stateAbbr = 'HI';
            }
            else if (zip >= 83200 && zip <= 83999) {
                stateAbbr = 'ID';
            }
            else if (zip >= 60000 && zip <= 62999) {
                stateAbbr = 'IL';
            }
            else if (zip >= 46000 && zip <= 47999) {
                stateAbbr = 'IN';
            }
            else if (zip >= 50000 && zip <= 52999) {
                stateAbbr = 'IA';
            }
            else if (zip >= 66000 && zip <= 67999) {
                stateAbbr = 'KS';
            }
            else if (zip >= 40000 && zip <= 42999) {
                stateAbbr = 'KY';
            }
            else if (zip >= 70000 && zip <= 71599) {
                stateAbbr = 'LA';
            }
            else if (zip >= 3900 && zip <= 4999) {
                stateAbbr = 'ME';
            }
            else if (zip >= 20600 && zip <= 21999) {
                stateAbbr = 'MD';
            }
            else if (zip >= 1000 && zip <= 2799) {
                stateAbbr = 'MA';
            }
            else if (zip >= 48000 && zip <= 49999) {
                stateAbbr = 'MI';
            }
            else if (zip >= 55000 && zip <= 56900) {
                stateAbbr = 'MN';
            }
            else if (zip >= 38600 && zip <= 39999) {
                stateAbbr = 'MS';
            }
            else if (zip >= 63000 && zip <= 65999) {
                stateAbbr = 'MO';
            }
            else if (zip >= 59000 && zip <= 59999) {
                stateAbbr = 'MT';
            }
            else if (zip >= 27000 && zip <= 28999) {
                stateAbbr = 'NC';
            }
            else if (zip >= 58000 && zip <= 58999) {
                stateAbbr = 'ND';
            }
            else if (zip >= 68000 && zip <= 69999) {
                stateAbbr = 'NE';
            }
            else if (zip >= 88900 && zip <= 89999) {
                stateAbbr = 'NV';
            }
            else if (zip >= 3000 && zip <= 3899) {
                stateAbbr = 'NH';
            }
            else if (zip >= 7000 && zip <= 8999) {
                stateAbbr = 'NJ';
            }
            else if (zip >= 87000 && zip <= 88499) {
                stateAbbr = 'NM';
            }
            else if (zip >= 10000 && zip <= 14999) {
                stateAbbr = 'NY';
            }
            else if (zip >= 43000 && zip <= 45999) {
                stateAbbr = 'OH';
            }
            else if (zip >= 73000 && zip <= 74999) {
                stateAbbr = 'OK';
            }
            else if (zip >= 97000 && zip <= 97999) {
                stateAbbr = 'OR';
            }
            else if (zip >= 15000 && zip <= 19699) {
                stateAbbr = 'PA';
            }
            else if (zip >= 300 && zip <= 999) {
                stateAbbr = 'PR';
            }
            else if (zip >= 2800 && zip <= 2999) {
                stateAbbr = 'RI';
            }
            else if (zip >= 29000 && zip <= 29999) {
                stateAbbr = 'SC';
            }
            else if (zip >= 57000 && zip <= 57999) {
                stateAbbr = 'SD';
            }
            else if (zip >= 37000 && zip <= 38599) {
                stateAbbr = 'TN';
            }
            else if ((zip >= 75000 && zip <= 79999) || (zip >= 88500 && zip <= 88599)) {
                stateAbbr = 'TX';
            }
            else if (zip >= 84000 && zip <= 84999) {
                stateAbbr = 'UT';
            }
            else if (zip >= 5000 && zip <= 5999) {
                stateAbbr = 'VT';
            }
            else if (zip >= 22000 && zip <= 24699) {
                stateAbbr = 'VA';
            }
            else if ((zip >= 20000 && zip <= 20599) || (zip >= 56901 && zip <= 56999)) {
                stateAbbr = 'DC';
            }
            else if (zip >= 98000 && zip <= 99499) {
                stateAbbr = 'WA';
            }
            else if (zip >= 24700 && zip <= 26999) {
                stateAbbr = 'WV';
            }
            else if (zip >= 53000 && zip <= 54999) {
                stateAbbr = 'WI';
            }
            else if (zip >= 82000 && zip <= 83199) {
                stateAbbr = 'WY';
            }
            else {
                stateAbbr = 'none';
            }
            return stateAbbr;
        };
    }
}
__decorate([
    mobx_1.observable
], GeneralStore.prototype, "menuOpen", void 0);
__decorate([
    mobx_1.action
], GeneralStore.prototype, "setMenuOpen", void 0);
__decorate([
    mobx_1.action
], GeneralStore.prototype, "exportAuditLogs", void 0);
exports.generalStore = new GeneralStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/store/store.ts
// module id = 640
// module chunks = 0